import DEFAULT from '..'
import { PartnerConfig } from '@/types'
import {
  familyMemberGenderField,
  familyMemberDateOfBirthField,
} from '../fieldLists'

const RegressionFullConfigFlow = (): PartnerConfig => ({
  branding: {
    logo: [
      {
        src: '/images/babylon.png',
        alt: 'Babylon logo config',
      },
      {
        src: '/images/GBR/nhs-services.png',
        alt: 'NHS Services logo',
      },
    ],
  },
  config: {
    name: 'Default Regression Flow',
    appName: DEFAULT.APPNAMES.BABYLON,
    acceptLanguage: 'en-GB',
    codes: {
      membership: '',
    },
    partnerUrlSlug: 'regression-full-flow',
    useDnaV2Design: false,
    steps: [
      {
        slug: 'welcome-test',
        component: 'welcome',
      },
      {
        slug: 'registration-test',
        component: 'registration',
      },
      {
        slug: 'family-test',
        component: 'family',
      },
      {
        slug: 'eligibility-test',
        component: 'eligibility',
      },
      {
        slug: 'thank-you-test',
        component: 'summary',
      },
    ],
    fields: [
      [DEFAULT.FIELDS.EMAIL],
      [
        DEFAULT.FIELDS.FIRST_NAME,
        DEFAULT.FIELDS.LAST_NAME,
        // Gender gets reset on re-render
        // TODO: Re-introduce when this issue will be fixed
        // DEFAULT.FIELDS.GENDER,
        DEFAULT.FIELDS.PASSWORD,
        {
          ...DEFAULT.FIELDS.CURRENT_GP,
          props: {
            options: [
              {
                label: 'Test 1',
                value: 'TEST1',
              },
              {
                label: 'My practioner',
                value: 'MY-MEMBERSHIP-CODE',
              },
              {
                label: 'Test 2',
                value: 'TEST2',
              },
              {
                label: 'Test 3',
                value: 'TEST3',
              },
              {
                label: 'Test 4',
                value: 'TEST4',
              },
            ],
          },
        },
        DEFAULT.FIELDS.DATE_OF_BIRTH,
        DEFAULT.FIELDS.PHONE_COUNTRY_CODE,
        DEFAULT.FIELDS.PHONE_NUMBER,
        DEFAULT.FIELDS.POSTCODE,
      ],
      [
        DEFAULT.FIELDS.FIRST_NAME,
        DEFAULT.FIELDS.LAST_NAME,
        familyMemberGenderField,
        familyMemberDateOfBirthField,
      ],
    ],
  },
  content: {
    'en-GB': {
      steps: [
        {
          title: 'Enter your email address',
          stepperLabel: 'Welcome',
          copy: [],
          productFeatures: [
            {
              icon: 'ChatFilled',
              title: 'Check your symptoms quickly and easily',
            },
            {
              icon: 'PeopleMedicalSpecialist',
              title: 'Talk to a doctor, 24/7',
            },
            {
              icon: 'Medication',
              title: 'Prescriptions sent to a local pharmacy of your choice',
            },
          ],
        },
        {
          title: 'Register',
          stepperLabel: 'Registration',
          copy: ['Add a few details to access 24/7 health support'],
        },
        {
          title: 'Add Family Members',
          stepperLabel: 'Family',
          copy: [
            'Before you finish, don’t forget to add any family members who also belong to your GP.',
          ],
        },
        { stepperLabel: 'Eligibility' },
        {
          title: 'Download the app',
          stepperLabel: 'Thank You',
          copy: [
            'Download and sign in to the app to book a Babylon video appointment 24/7.',
          ],
          imgUrl: '/images/babylon-ios-app.png',
          dnaV2DesignImgUrl: '/images/babylon-ios-app.png',
          cta: {
            showDownloadButtons: true,
          },
        },
      ],
      footerLinks: DEFAULT.FOOTERLINKS.GBR,
    },
  },
})

export default RegressionFullConfigFlow
